module.exports = __webpack_public_path__ + "media/homepage/course-hero_@2x-86956b27.png";